import AFloorInfo from './a-floor-info';

export default AFloorInfo;